<template>
    <div class="cs-student-course-container">
        <!-- <el-row>
            <el-button type="text" icon="el-icon-arrow-left" @click="back">返回</el-button>
        </el-row>
        <el-row>&nbsp;</el-row> -->
        <el-row>
          <el-col>
            <!-- <span class="cs-title">在校课程时间表</span>
  <el-row>&nbsp;</el-row> -->
            <el-row>
              <el-col :span="24">
                <strong><label class="el-form-item__label float-left">电话号码：</label></strong>
                <label class="el-form-item__label float-left" v-text="formatPhone(this.phone)"></label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <strong><label class="el-form-item__label float-left">所属大学：</label></strong>
                <label class="el-form-item__label float-left" v-text="this.universityName"></label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <strong><label class="el-form-item__label float-left">报名速成课程：</label></strong>
                <label class="el-form-item__label float-left" v-text="this.speedupCourse"></label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <strong><label class="el-form-item__label float-left">在校课程：</label></strong>
                <label class="el-form-item__label float-left" v-html="this.universityCourseSuggestion"></label>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <el-col>
                <courseCalendar :options="{
                    start:GLOBAL.courseScheduleSetting.start,
                    end:GLOBAL.courseScheduleSetting.end
                  }" v-loading="loading" :schedules="courseSchedules"></courseCalendar>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
    </div>
</template>


<style lang="scss" scoped>
.cs-student-course-container {
  padding: 10px 40px 10px 40px;

  .grid-content {
    margin-top: 15px;
    .cs-schedule-buttonContainer {
      text-align: right;
    }
  }
  label {
    &.el-form-item__label {
      line-height: 20px;
    }
  }
  button {
    &.el-button--text {
      color: black;
      font-size: 15px;
    }
  }
}

</style>

<script>
import courseCalendar from "./courseCalendar";
import { getUniversityGroups } from "../service/common.service";
import { getStudentCourse } from "../service/course.service";
import { getStudent } from "../service/student.service";
import { getPlanCourseList,getSpeedupCoursePlans } from "../service/speedupCourse.service";
import { getColorList,formatPhone } from "../config/mUtils";
export default {
  data() {
    return {
      loading: false,
      courseSchedules: [],
      courseDataAll: [],
      studentId: 0,
      planId: 0,
      termId: 0,
      universityId: 0,
      universityGroupId: 0,
      phone: "",
      universityName: "",
      speedupCourse: "",
      universityCourseSuggestion: "", 
      universityCourse: [],
      speedupCoursePlan :[]
    };
  },
  props: {
    data: {}
  },
  components: {
    courseCalendar
  },
  created() {
    this.loadData();
  },
  methods: {
    formatPhone(phone){
      if (!this.USERMANAGER.isAdmin){
        return formatPhone(phone);
      }
      return phone;
    },
    loadData() {
     
      if (!this.data) return;

      this.studentId = this.data.studentId;
      this.planId = this.data.planId;
      this.termId = this.data.termId;
      
      this.loadStudentInfo(this.studentId, this.planId);
      //if (!this.data.phone) {
      //  this.loadStudentInfo(this.studentId, this.planId);

      //} else {
      //  this.phone = this.data.phone;
      //  this.universityName = this.data.universityName;
      //  this.speedupCourse = this.data.speedupCourse;
      //  this.universityId = this.data.universityId;
      //}

      this.loadStudentCourseSchedule(this.studentId, this.planId, this.termId);

      
    },
    loadStudentInfo(id, planId) {
      getStudent(id).then(result => {
        if (result.success) {
          this.phone = result.data.Phone;
          this.universityName = result.data.UniversityName;
          this.speedupCourse = result.data.SpeedupCourse;
          this.universityId = result.data.UniversityId;
          this.loadUniversityGroup();
        }
      });
    },
    loadStudentCourseSchedule(id, planId, termId) {
      if (!id) {
        this.courseSchedules = [];
        return;
      }

      this.loading = true;
      getStudentCourse(id, planId, termId).then(result => {
        //Clear all previous courses
        this.universityCourse = [];
        if (result.success) {
          this.courseDataAll = result.data;
          let colorList = getColorList();
          let scheduleList = [];
          let courseColor = {};
          let index = 0;
          result.data.forEach(course => {
            let courseName = course.CourseName;
            if (course.IsSpeedupCourse) {
              if (course.CourseClass > 0) {
                courseName += "-分班" + course.CourseClass;
              }
            }
            let courseId = course.Id;
            if (!courseColor[courseId]) {
              let color = colorList[index];
              courseColor[courseId] = color;
              index++;
            }
            course.ScheduleList.forEach(element => {
              let dayofweek = element.DayOfWeek;
              if (dayofweek == 0) {
                dayofweek = 7;
              }
              let item = {
                isSpeedupCourse:course.IsSpeedupCourse,
                color: courseColor[courseId],
                starttime: element.StartTimeText,
                endtime: element.EndTimeText,
                dayofweek: dayofweek,
                title: courseName,
                text: "",
                tooltipText:
                element.StartTimeText + " - " + element.EndTimeText,
                keyValue: courseId,
                dataId: element.Id
              };
              scheduleList.push(item);
              let newCourseName = this.courseNameCleanUp(courseName);
              if (!this.universityCourse.includes(newCourseName) && (!newCourseName.startsWith("SP-"))) {
                this.universityCourse.push(newCourseName);
              }
              
            });
          });
          this.courseSchedules = scheduleList;
        }

        this.loading = false;
      });

    }, loadSpeedupCourseList(termId, universityGroupId) {
      this.speedupCoursePlan = [];
      getSpeedupCoursePlans(termId, universityGroupId).then(result => {
            if (result.success) {
              result.data.forEach(element => {
                if (element.Selected) {
                  getPlanCourseList(termId,element.Id).then(result => {
                  if (result.success) {
                    //this.speedupCoursePlan = result.data;
                    this.speedupCoursePlan = [];
                    result.data.forEach(course => {
                      this.speedupCoursePlan.push(course.CourseName);
                      
                    });
                      this.potentialCourse(this.universityCourse, this.speedupCoursePlan);

                  }
                  });

                }

              });
              
            }
        });


    }, potentialCourse(uCourse, spCourse) {
      let n = [];
      let enrolledSPCourses = this.speedupCourse.split(",");
      uCourse.forEach(uc => {
        let added = false;
        //Check Enrolled SP Courses
        enrolledSPCourses.forEach(spc => {
          if ((!added) && (spc.includes(uc))) {
              n.push(uc);
              added = true;
          }
        });
        //Check All SP Courses
        spCourse.forEach(spc => {
          if ((!added) && (spc.includes(uc))) {
            if ((!n.includes("#" + uc)) && (!n.includes(uc))) {
              n.push("#" + uc);
              added = true;
            }
          }
        });
        
        if (!added) {
            n.push(uc);
          }
      });
      this.universityCourseSuggestion = "";
      n.forEach(uc => {
        if (uc.startsWith("#")) {
          this.universityCourseSuggestion += "<span style='color:red;'>" + uc.substring(1, uc.length) + "</span>";
        } else {
          this.universityCourseSuggestion += uc;
        }
        this.universityCourseSuggestion += ", ";
      });
      this.universityCourseSuggestion = this.universityCourseSuggestion.substring(0, this.universityCourseSuggestion.length-2);

    }, loadUniversityGroup() {
      getUniversityGroups().then(result => {
        result.data.forEach(g => {
          if (g.IdValue.includes(this.universityId)) {
            this.universityGroupId = g.GroupNumber;
          }
        });
      this.loadSpeedupCourseList(this.termId, this.universityGroupId);

      });
    },
    courseNameCleanUp(cName) {
      return cName.toUpperCase().trim().replace(' ', '');
    }
    ,
    back() {
      this.$emit("close");
      //this.$router.push("/admin/studentList");
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/components/studentCourseReview.vue